'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTag, iconTagTag } from '@ni/nimble-components/dist/esm/icons/tag';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTag };
export { iconTagTag };
export const NimbleIconTag = wrap(IconTag);